import { add } from 'date-fns';
import { Asset, AssetLog, AssetOverview } from './asset';
import { Plan } from './plan';
import { Project, ProjectSummary } from './project';
import { Report } from './report';
import { User } from './user';

export const assetFactory = (code: string): Asset => ({
    code,
    name: '',
    picture: '',
    psm: false,
    comment: '',
    metadata: {},
    inspection_plan: undefined,
    type: undefined,
    company: undefined,
    area: undefined,
    business_unit: undefined,
    operating_system: undefined,
    cost_center: undefined,
});

export const planFactory = (assetCode: string): Plan => ({
    id: -1,
    blueprint_damages: [],
    revision_history: [],
    program_implementation: 'low',
    internal_inspection_interval: 0,
    external_inspection_interval: 0,
    internal_due_date: new Date(),
    external_due_date: new Date(),
    draft_data: {},
    asset: { code: assetCode } as any,
    inspection_plan_group: undefined,
    inspection_activity: [],
    damage_mechanism: [],
    thickness_requirement: undefined,
    risk_assessment: undefined,
    reference_documents: [],
});

export const projectFactory = (planId: number): Project => ({
    id: -1,
    type: 'combined',
    priority: 'low',
    op_cost_center: '',
    status: 'ready to inspect',
    created_date: new Date(),
    in_progress_date: new Date(0),
    awaiting_report_date: new Date(0),
    under_review_date: new Date(0),
    completed_date: new Date(0),
    estimated_start_date: new Date(),
    estimated_completed_date: new Date(),
    weekend: false,
    manpower: 0,
    estimated_cost: 0.0,
    cost: 0.0,
    report: '',
    findings: '',
    comment: '',
    follow_up_actions: '',
    suggested_follow_up_inspection_interval: 0,
    asset_status: 'n/a',
    preparation_steps: {},
    methods: {},
    outage: '',
    heavy_cleaning: false,
    crhm: false,
    gd: false,
    rope_access: false,
    internal_scaffold: false,
    external_vt_due: new Date(0),
    ndt_due: new Date(0),
    internal_due_date: new Date(0),
    internal_scaffold_cost: 0.0,
    internal_status: '',
    ip_status: '',
    inspection_plan: planId,
    category: undefined,
    user: undefined,
});

export const assetLogFactory = (): AssetLog => ({
    status: 'planned',
    date: new Date(),
});

export const assetOverviewFactory = (): AssetOverview => ({
    code: '1234',
    name: 'Mock Asset',
    psm: true,
    type: 'Mock Type',
    consequence_risk: 'low',
    likelihood_risk: 'low',
    external_due_date: new Date(),
    internal_due_date: new Date(),
    last_external: new Date(),
    last_internal: new Date(),
});

export const projectSummaryFactory = (code: string, name: string): ProjectSummary => ({
    code,
    name,
    psm: false,
    inspection_type: undefined,
    plan: undefined,
    inspection: -1,
    internal_due_date: new Date(),
    external_due_date: new Date(),
    likelihood_risk: undefined,
    consequence_risk: undefined,
    status: undefined,
    in_progress_date: undefined,
    completed_date: undefined,
    estimated_start_date: undefined,
    estimated_completed_date: undefined,
    rope_access: undefined,
    internal_scaffold: undefined,
    heavy_cleaning: undefined,
});

export const userFactory = (): User => ({
    id: -1,
    username: 'factory',
    full_name: 'factory user',
    picture: '',
    groups: [],
});

export const reportFactory = (): Report => ({
    id: -1,
    title: '',
    created_date: new Date(),
    start_date: new Date(),
    end_date: add(new Date(), { months: 1, days: -1 }),
    user: undefined,
    asset_type_filters: [],
    area_filters: [],
    cost_center_filters: [],
});
